import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { FHIRHelper, IPractitionerTemplate, Practitioner, TemplateDocCategory } from "@comunicare/comunicare-interfaces";
import { combineLatest, Observable } from "rxjs";
import { first } from "rxjs/operators";
import { PractitionerService } from "src/app/providers/practitioner.service";
import { PrescriptionService } from "src/app/providers/prescription.service";
import { ImportPrescriptionTemplateModalComponent } from "../import-prescription-template-modal/import-prescription-template-modal.component";

@Component({
  selector: "app-prescription-template-modal",
  templateUrl: "./prescription-template-modal.component.html",
  styleUrls: ["./prescription-template-modal.component.scss"],
})
export class PrescriptionTemplateModalComponent {
  public isLoading = false;
  public displayedColumns: string[] = ["practitioner", "name", "actions"];
  constructor(
    public dialogRef: MatDialogRef<PrescriptionTemplateModalComponent>,
    private prescriptionService: PrescriptionService,
    private dialog: MatDialog,
    public practitionerService: PractitionerService,
    @Inject(MAT_DIALOG_DATA)
    public data: { service: string; templates: IPractitionerTemplate[]; doctorSelected: Practitioner; availableDoctors: Practitioner[] }
  ) {}

  public import(event: { target: { files: FileList } }): void {
    const dialogRef = this.dialog.open(ImportPrescriptionTemplateModalComponent, {
      data: { doctorSelected: this.data.doctorSelected, availableDoctors: this.data.availableDoctors },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const files = event.target.files;
        const uploadSubs: Observable<IPractitionerTemplate>[] = [];
        if (files?.length) {
          for (let i = 0; i < files.length; i++) {
            uploadSubs.push(
              this.prescriptionService.createPrescriptionTemplates(
                files.item(i),
                FHIRHelper.getMainIdentifier(result.practitioner)?.value,
                TemplateDocCategory.SIGNATURE_TLS,
                result.availableToService
              )
            );
          }
          this.isLoading = true;
          combineLatest(uploadSubs)
            .pipe(first())
            .subscribe((templates) => {
              this.dialogRef.close(templates);
            });
        }
      }
    });
  }

  public validate(template: IPractitionerTemplate): void {
    this.dialogRef.close([template]);
  }

  public onDelete(template: IPractitionerTemplate): void {
    this.isLoading = true;
    this.prescriptionService
      .deletePrescriptionTemplate(template.identifier)
      .pipe(first())
      .subscribe(() => {
        const index = this.data.templates.findIndex((t) => t.identifier === template.identifier);
        if (index !== -1) {
          this.data.templates.splice(index, 1);
        }
        this.isLoading = false;
      });
  }
}
